import React from "react";
import {
  Box,
  Grid2,
  Typography,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import { styled } from "@mui/material/styles";
import ContentLayout from "../layouts/ContentLayout";
import StatisticsCard from "../layouts/statisticspage/StatisticsCard";

import { useStatisticsQuery } from "../hooks/useStatistics/useStatisticsQuery";
import { graphCardtexts } from "../constants/statisticsTexts";
import { isDebug } from "../utils";


const TypographySx = styled(Typography)(({ theme }) => ({
  ...theme.typography.h5,
  textAlign: "left",
  position: "absolute",
  left: "10%",
  top: "12%",
}));


const StatisticsPage = () => {
  const { data: statisticsData, isLoading, isError } = useStatisticsQuery({});
  const { t } = useTranslation();

  if (isDebug()) console.log("##statisticsData", statisticsData);
  const cardsData = graphCardtexts(statisticsData);

  React.useEffect(() => {
    document.title = 'BWOB - ' + t('nav.statics');  
  }, []);

  
  return (
    <ContentLayout pageTitle={t('nav.statics')} pageDescription={""} >
      &nbsp;
      
      <Box sx={{ flexGrow: 1 }}>

        <Grid2
          container
          spacing={4}
          sx={{ justifyContent: "flex-end", marginBottom: 4 }}
        >
          <StatisticsCard card={cardsData[0]} />
          <StatisticsCard card={cardsData[1]} />
          <StatisticsCard card={cardsData[5]} />
        </Grid2>
        
        <Grid2 container spacing={4} sx={{ justifyContent: "flex-end" }}>
          <StatisticsCard card={cardsData[2]} />
          <StatisticsCard card={cardsData[3]} />
          <StatisticsCard card={cardsData[4]} />
        </Grid2>

      </Box>

    </ContentLayout>
  );
};

export default StatisticsPage;
